import { IWaitListImportColumnMapping } from "@nkr/models/recipients/waitlist-import-column-mapping";
import { IWaitlistImportResults } from "@nkr/models/recipients/waitlist-import-results";
import { Alert, Button, Glyphicon, Label, Panel, PanelHeading, Table } from "react-bootstrap";
import { PatientsNotInFile } from "./patients-not-in-file";
import { TableWrapper } from "./styles";
import { WaitlistImportStatus } from "./waitlist-import-status";

interface IProps {
    data: IWaitlistImportResults,
    patientsNotInFile: PatientsNotInFile,
    columnMapping: IWaitListImportColumnMapping[],
    onPreviousStep: () => void,
    onProcessFile: () => void
}

const ReviewMappingResults = (props: IProps) => {
    const handleProcessFile = () => {
        props.onProcessFile();
    };

    const getHasRowsToProcess = () => {
        let inFile = props.data.items.filter(x => x.isInFile && x.statusId != WaitlistImportStatus.Ignore && x.statusId != WaitlistImportStatus.Skip);
        let notInFile = props.data.items.filter(x => x.isInFile == false);

        return inFile.length > 0 || notInFile.length > 0;
    };

    if (props.data == null)
        return null;

    const inFile = props.data.items.filter(x => x.isInFile);
    const notInFile = props.data.items.filter(x => x.isInFile == false);
    const hasRowsToProcess = getHasRowsToProcess();

    const createList = inFile.filter(x => x.statusId == WaitlistImportStatus.Create);
    const updateList = inFile.filter(x => x.statusId == WaitlistImportStatus.Update);
    const skipList = inFile.filter(x => x.statusId == WaitlistImportStatus.Skip || x.statusId == WaitlistImportStatus.NotOnWaitlist);

    return (
        <Panel>
            <Panel.Heading>Step 3: Review Pending Results</Panel.Heading>
            <Panel.Body>
                {!hasRowsToProcess && (
                    <Alert bsStyle='warning' style={{ paddingTop: 7.5, paddingBottom: 7.5 }}>
                        There are no rows to process in the uploaded file
                    </Alert>
                )}

                <Panel>
                    <Panel.Heading>
                        Items to be <strong>CREATED</strong>
                    </Panel.Heading>
                    <Panel.Body style={{ padding: 5 }}>
                        <TableWrapper condensed bordered tightspacing='1'>
                            <thead>
                                <tr>
                                    <th>File<br />Row&nbsp;#<br /></th>
                                    <th>MRN</th>
                                    <th>First<br />Name</th>
                                    <th>Last<br />Name</th>
                                    <th>Alias</th>
                                    <th>Birth<br />Date</th>
                                    <th>Address</th>
                                    <th>City</th>
                                    <th>State</th>
                                    <th>Postal<br />Code</th>
                                    <th>Phone #</th>
                                    <th>Ht</th>
                                    <th>Wt</th>
                                    <th>Gender</th>
                                </tr>
                            </thead>
                            <tbody>
                                {createList.map(item =>
                                    <tr key={'item-' + item.mrn}>
                                        <td>{item.rowNumber}</td>
                                        <td>{item.mrn}</td>
                                        <td>{item.firstName}</td>
                                        <td>{item.lastName}</td>
                                        <td>{item.alias}</td>
                                        <td>{item.birthDate}</td>
                                        <td>{item.address}</td>
                                        <td>{item.city}</td>
                                        <td>{item.state}</td>
                                        <td>{item.postalCode}</td>
                                        <td>{item.phoneNumber}</td>
                                        <td>{item.height}</td>
                                        <td>{item.weight}</td>
                                        <td>{item.gender}</td>
                                    </tr>
                                )}

                                {createList.length == 0 && (
                                    <tr>
                                        <td colSpan={14}>
                                            No rows to create...
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </TableWrapper>
                    </Panel.Body>
                </Panel>

                <Panel>
                    <Panel.Heading>
                        Items to be <strong>UPDATED</strong>
                    </Panel.Heading>
                    <Panel.Body style={{ padding: 5 }}>
                        <TableWrapper condensed bordered tightspacing='1'>
                            <thead>
                                <tr>
                                    <th>File<br />Row&nbsp;#<br /></th>
                                    <th>MRN</th>
                                    <th>First<br />Name</th>
                                    <th>Last<br />Name</th>
                                    <th>Alias</th>
                                    <th>Birth<br />Date</th>
                                    <th>Address</th>
                                    <th>City</th>
                                    <th>State</th>
                                    <th>Postal<br />Code</th>
                                    <th>Phone #</th>
                                    <th>Ht</th>
                                    <th>Wt</th>
                                    <th>Gender</th>
                                </tr>
                            </thead>
                            <tbody>
                                {updateList.map(item =>
                                    <tr key={'item-' + item.mrn}>
                                        <td>{item.rowNumber}</td>
                                        <td>{item.mrn}</td>
                                        <td>{item.firstName}</td>
                                        <td>{item.lastName}</td>
                                        <td>{item.alias}</td>
                                        <td>{item.birthDate}</td>
                                        <td>{item.address}</td>
                                        <td>{item.city}</td>
                                        <td>{item.state}</td>
                                        <td>{item.postalCode}</td>
                                        <td>{item.phoneNumber}</td>
                                        <td>{item.height}</td>
                                        <td>{item.weight}</td>
                                        <td>{item.gender}</td>
                                    </tr>
                                )}

                                {updateList.length == 0 && (
                                    <tr>
                                        <td colSpan={14}>
                                            No rows to update...
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </TableWrapper>
                    </Panel.Body>
                </Panel>

                <Panel>
                    <Panel.Heading style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <span>Items to be <strong>SKIPPED</strong></span>
                        <span>
                            {/* <div style={{ backgroundColor: 'yellow', padding: '1px 5px' }}>Not on waitlist</div> */}
                        </span>
                    </Panel.Heading>
                    <Panel.Body style={{ padding: 5 }}>
                        <TableWrapper condensed bordered tightspacing='1'>
                            <thead>
                                <tr>
                                    <th>File<br />Row&nbsp;#<br /></th>
                                    <th>MRN</th>
                                    <th>First<br />Name</th>
                                    <th>Last<br />Name</th>
                                    <th>Alias</th>
                                    <th>Birth<br />Date</th>
                                    <th>Address</th>
                                    <th>City</th>
                                    <th>State</th>
                                    <th>Postal<br />Code</th>
                                    <th>Phone #</th>
                                    <th>Ht</th>
                                    <th>Wt</th>
                                    <th>Gender</th>
                                    <th>Reason</th>
                                </tr>
                            </thead>
                            <tbody>
                                {skipList.map(item =>
                                    <tr key={'item-' + item.mrn}>
                                        <td>{item.rowNumber}</td>
                                        <td>{item.mrn}</td>
                                        <td>{item.firstName}</td>
                                        <td>{item.lastName}</td>
                                        <td>{item.alias}</td>
                                        <td>{item.birthDate}</td>
                                        <td>{item.address}</td>
                                        <td>{item.city}</td>
                                        <td>{item.state}</td>
                                        <td>{item.postalCode}</td>
                                        <td>{item.phoneNumber}</td>
                                        <td>{item.height}</td>
                                        <td>{item.weight}</td>
                                        <td>{item.gender}</td>
                                        <td>
                                            {item.statusId == WaitlistImportStatus.Skip && (
                                                <Label>Already exists</Label>
                                            )}

                                            {item.statusId == WaitlistImportStatus.NotOnWaitlist && (
                                                <Label bsStyle='info'>Not on waitlist</Label>
                                            )}

                                            {item.statusId == WaitlistImportStatus.Inactive && (
                                                <Label bsStyle='warning'>Inactive</Label>
                                            )}

                                            {item.statusId == WaitlistImportStatus.Deleted && (
                                                <Label bsStyle='danger'>Deleted</Label>
                                            )}
                                        </td>
                                    </tr>
                                )}

                                {skipList.length == 0 && (
                                    <tr>
                                        <td colSpan={14}>
                                            No rows to skip...
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </TableWrapper>
                    </Panel.Body>
                </Panel>

                {props.patientsNotInFile != PatientsNotInFile.Ignore && (
                    <Panel>
                        <Panel.Heading>
                            Not Found In File
                        </Panel.Heading>
                        <Panel.Body style={{ padding: 5 }}>
                            <TableWrapper condensed bordered tightspacing='1'>
                                <thead>
                                    <tr>
                                        <th>MRN</th>
                                        <th>First Name</th>
                                        <th>Last Name</th>
                                        <th>Birth Date</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {notInFile.map(item =>
                                        <tr key={'item-' + item.mrn}>
                                            <td>{item.mrn}</td>
                                            <td>{item.firstName}</td>
                                            <td>{item.lastName}</td>
                                            <td>{item.birthDate}</td>
                                        </tr>
                                    )}

                                    {notInFile.length == 0 && (
                                        <tr>
                                            <td colSpan={4}>
                                                No rows pending...
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </TableWrapper>
                        </Panel.Body>
                    </Panel>
                )}

                <Panel>
                    <Panel.Heading>
                        Rows With Issues
                    </Panel.Heading>
                    <Panel.Body style={{ padding: 5 }}>
                        <TableWrapper condensed bordered tightspacing='1'>
                            <thead>
                                <tr>
                                    <th style={{ width: 59, textAlign: 'center' }}>Row #</th>
                                    <th>Issues</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.data.invalidRows.map(row =>
                                    <tr key={'invalid-row-' + row.rowIndex}>
                                        <td style={{ textAlign: 'center' }}>{row.rowIndex}</td>
                                        <td>
                                            {row.messages.map((message, index) =>
                                                <div key={'imvalid-row-' + row.rowIndex + '-msg-' + index}>{message}</div>
                                            )}
                                        </td>
                                    </tr>
                                )}

                                {props.data.invalidRows.length == 0 && (
                                    <tr>
                                        <td colSpan={2}>No rows with issues...</td>
                                    </tr>
                                )}
                            </tbody>
                        </TableWrapper>
                    </Panel.Body>
                </Panel>
            </Panel.Body>
            <Panel.Footer className='text-right'>
                <Button bsStyle='link' onClick={props.onPreviousStep}><Glyphicon glyph='chevron-left' /> Previous Step</Button>&nbsp;
                <Button bsStyle='primary' disabled={!hasRowsToProcess} title={!hasRowsToProcess ? 'There are no rows found to process' : 'Click here to process the file'} onClick={handleProcessFile}>Process File</Button>
            </Panel.Footer>
        </Panel>
    );
}

export default ReviewMappingResults;